import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from './Legal.module.css';

export default function Terms() {
  return (
    <section className={styles.section}>
      <Helmet>
        <title>Пользовательское соглашение — ООО Советник</title>
        <meta name="description" content="Пользовательское соглашение сайта konsultant-sovetnik.ru. Условия использования сайта ООО Советник." />
        <link rel="canonical" href="https://konsultant-sovetnik.ru/terms" />
      </Helmet>
      <div className={styles.container}>
        <h1 className={styles.title}>Пользовательское соглашение</h1>
        <p className={styles.date}>Дата последнего обновления: 17 марта 2026 г.</p>

        <div className={styles.content}>
          <h2>1. Общие положения</h2>
          <p>
            Настоящее Пользовательское соглашение (далее — Соглашение) регулирует условия
            использования сайта konsultant-sovetnik.ru (далее — Сайт), принадлежащего
            ООО «Советник» (далее — Компания).
          </p>
          <p>
            Используя Сайт, Пользователь подтверждает своё согласие с условиями настоящего
            Соглашения. Если Пользователь не согласен с условиями, он должен прекратить
            использование Сайта.
          </p>

          <h2>2. Предмет соглашения</h2>
          <p>
            Компания предоставляет Пользователю доступ к информационным материалам Сайта,
            а также возможность направления запросов через формы обратной связи для получения
            консультационных услуг в сфере внешнеэкономической деятельности.
          </p>

          <h2>3. Права и обязанности сторон</h2>
          <h3>3.1. Пользователь обязуется:</h3>
          <ul>
            <li>Предоставлять достоверную информацию при заполнении форм на Сайте</li>
            <li>Не использовать Сайт в целях, противоречащих законодательству РФ</li>
            <li>Не предпринимать действий, направленных на нарушение работы Сайта</li>
          </ul>
          <h3>3.2. Компания обязуется:</h3>
          <ul>
            <li>Обеспечивать работоспособность Сайта</li>
            <li>Обрабатывать запросы Пользователей в разумные сроки</li>
            <li>Обеспечивать защиту персональных данных в соответствии с Политикой конфиденциальности</li>
          </ul>

          <h2>4. Ответственность</h2>
          <p>
            Информация, размещённая на Сайте, носит информационный характер и не является
            публичной офертой. Компания не несёт ответственности за решения, принятые
            Пользователем на основании информации, размещённой на Сайте, без предварительной
            индивидуальной консультации.
          </p>

          <h2>5. Интеллектуальная собственность</h2>
          <p>
            Все материалы, размещённые на Сайте (тексты, изображения, логотипы, дизайн),
            являются интеллектуальной собственностью Компании и защищены законодательством
            Российской Федерации. Копирование и распространение материалов без письменного
            согласия Компании запрещено.
          </p>

          <h2>6. Порядок разрешения споров</h2>
          <p>
            Все споры и разногласия решаются путём переговоров. В случае невозможности
            достижения соглашения споры подлежат рассмотрению в суде по месту нахождения Компании
            в соответствии с законодательством Российской Федерации.
          </p>

          <h2>7. Изменение условий</h2>
          <p>
            Компания оставляет за собой право вносить изменения в настоящее Соглашение.
            Актуальная версия Соглашения размещается на данной странице. Продолжение использования
            Сайта после внесения изменений означает согласие с новой редакцией Соглашения.
          </p>

          <h2>8. Контактная информация</h2>
          <p>
            ООО «Советник»<br />
            Адрес: Россия, г. Тверь, пер. Спортивный, д.1А, оф.9<br />
            Email: <a href="mailto:info@konsultant-sovetnik.ru">info@konsultant-sovetnik.ru</a><br />
            Телефон: <a href="tel:+79109369889">+7 (910) 936-98-89</a>
          </p>
        </div>
      </div>
    </section>
  );
}
